import {
	mapActions,
	mapGetters
} from 'vuex';

import {
	DatePicker
} from 'element-ui';

import moment from 'moment';

export default {
	name: 'medicine-filters',
	components: {
		DatePicker
	},
	data: () => ({
		datepicker: {
			today: new Date(),
			selected: new Date()
		},
		student: ''
	}),
	computed: {
		...mapGetters({
			user: 'getLoggedUser'
		})
	},
	methods: {
		...mapActions([
			'putFilterSearchMedicine',
			'getMedicine',
			'getMedicineIsTaken',
			'setMedicineHistory',
			'setMedicinePending'
		]),
		filter() {

			return this.getMedicine({
				user: this.user.id,
				filter: {
					date: moment(this.datepicker.selected).format('YYYY-MM-DD'),
					studentName: this.student
				}
			}).then((response) => {

				this.getMedicineIsTaken(true).then((response) => {
					this.setMedicineHistory(response);
				});

				this.getMedicineIsTaken(false).then((response) => {
					this.setMedicinePending(response);
				});

				return response;

			});

		}
	}
};



// WEBPACK FOOTER //
// ./sources/domains/medicine/medicine-filters/index.js